import Layout1 from '@/layout/Layout1'

export default [{
  path: '/edisbursement',
  component: Layout1,
  children: [{
    path: 'paymentnature/:id',
    component: () => import('@/components/edisbursement/maintenance/paymentnatures/paymentnatureEdit')
  }, {
    path: 'paymentnature',
    component: () => import('@/components/edisbursement/maintenance/paymentnatures/paymentnatureList')
  }, {
    path: 'paymentform/:id',
    component: () => import('@/components/edisbursement/maintenance/paymentforms/paymentformEdit')
  }, {
    path: 'paymentform',
    component: () => import('@/components/edisbursement/maintenance/paymentforms/paymentformList')
  }, {
    path: 'cashaccount/:id',
    component: () => import('@/components/edisbursement/maintenance/cashaccounts/cashaccountEdit')
  }, {
    path: 'cashaccount',
    component: () => import('@/components/edisbursement/maintenance/cashaccounts/cashaccountList')
  }, {
    path: 'disbursement/:id',
    component: () => import('@/components/edisbursement/transaction/disbursements/disbursementEdit')
  }, {
    path: 'disbursement',
    component: () => import('@/components/edisbursement/transaction/disbursements/disbursementList')
  }, {
    path: 'unitapproval/:id',
    component: () => import('@/components/edisbursement/transaction/unitapprovals/unitapprovalEdit')
  }, {
    path: 'unitapproval',
    component: () => import('@/components/edisbursement/transaction/unitapprovals/unitapprovalList')
  }, {
    path: 'accountingapproval/:id',
    component: () => import('@/components/edisbursement/transaction/accountingapproval/accountingapprovalEdit')
  }, {
    path: 'accountingapproval',
    component: () => import('@/components/edisbursement/transaction/accountingapproval/accountingapprovalList')
  }, {
    path: 'unitapprovalrouting/:id',
    component: () => import('@/components/edisbursement/maintenance/unitapprovalrouting/unitapprovalroutingEdit')
  }, {
    path: 'unitapprovalrouting',
    component: () => import('@/components/edisbursement/maintenance/unitapprovalrouting/unitapprovalroutingList')
  }, {
    path: 'accountingapprovalrouting/:id',
    component: () => import('@/components/edisbursement/maintenance/accountingapprovalrouting/accountingapprovalroutingEdit')
  }, {
    path: 'accountingapprovalrouting',
    component: () => import('@/components/edisbursement/maintenance/accountingapprovalrouting/accountingapprovalroutingList')
  }, {
    path: 'disbursementinquiry',
    component: () => import('@/components/edisbursement/inquiry/disbursements/disbursementInquiry')
  }, {
    path: 'approvalinquiry',
    component: () => import('@/components/edisbursement/inquiry/disbursementsapproval/approvalInquiry')
  }, {
    path: 'completedpaymentrequestsinquiry',
    component: () => import('@/components/edisbursement/inquiry/completedpaymentrequests/completedpaymentrequestsInquiry')
  }, {
    path: 'approvallog',
    component: () => import('@/components/edisbursement/inquiry/approvallogs/approvallogList')
  }, {
    path: 'approvallog/:id',
    component: () => import('@/components/edisbursement/inquiry/approvallogs/approvallogEdit')
  }, {
    path: 'detaileddisbursement',
    component: () => import('@/components/edisbursement/inquiry/detaileddisbursements/detaileddisbursementList')
  }, {
    path: 'detaileddisbursement/:id',
    component: () => import('@/components/edisbursement/inquiry/detaileddisbursements/detaileddisbursementEdit')
  }, {
    path: 'disbursementtransmittal',
    component: () => import('@/components/edisbursement/inquiry/disbursementtransmittals/disbursementtransmittalList')
  }, {
    path: 'disbursementtransmittal/:id',
    component: () => import('@/components/edisbursement/inquiry/disbursementtransmittals/disbursementtransmittalEdit')
  }, {
    path: 'completedprconfidentialsInquiry',
    component: () => import('@/components/edisbursement/inquiry/completedprconfidentials/completedprconfidentialsInquiry')
  }, {
    path: 'accountingwiretransfer',
    component: () => import('@/components/edisbursement/inquiry/accountingwiretransfers/accountingwiretransfersInquiry')
  }, {
    path: 'completedpriotinquiry',
    component: () => import('@/components/edisbursement/inquiry/completedpriot/completedpriotinquiry')
  }, {
    path: 'payeelog',
    component: () => import('@/components/edisbursement/inquiry/payeeslogs/payeelogList')
  }, {
    path: 'payeelog/:id',
    component: () => import('@/components/edisbursement/inquiry/payeeslogs/payeelogEdit')
  }, {
    path: 'fundtransfer',
    component: () => import('@/components/edisbursement/inquiry/fundstransfers/fundtransferList')
  }, {
    path: 'fundtransfer/:id',
    component: () => import('@/components/edisbursement/inquiry/fundstransfers/fundtransferEdit')
  }, {
    path: 'newpayee',
    component: () => import('@/components/edisbursement/inquiry/newpayees/newpayeeList')
  }, {
    path: 'newpayee/:id',
    component: () => import('@/components/edisbursement/inquiry/newpayees/newpayeeEdit')
  }, {
    path: 'wiretransfer',
    component: () => import('@/components/edisbursement/inquiry/wiretransfers/wiretransferList')
  }, {
    path: 'wiretransfer/:id',
    component: () => import('@/components/edisbursement/inquiry/wiretransfers/wiretransferEdit')
  }, {
    path: 'officesite/:id',
    component: () => import('@/components/edisbursement/maintenance/officesites/officesiteEdit')
  }, {
    path: 'officesite',
    component: () => import('@/components/edisbursement/maintenance/officesites/officesiteList')
  }, {
    path: 'vendorapplication/:id',
    component: () => import('@/components/edisbursement/transaction/vendorapplication/vendorapplicationEdit')
  }, {
    path: 'vendorapplication',
    component: () => import('@/components/edisbursement/transaction/vendorapplication/vendorapplicationList')
  }, {
    path: 'unbudgetedaccount/:id',
    component: () => import('@/components/edisbursement/maintenance/unbudgetedaccounts/unbudgetedaccountEdit')
  }, {
    path: 'unbudgetedaccount',
    component: () => import('@/components/edisbursement/maintenance/unbudgetedaccounts/unbudgetedaccountList')
  }, {
    path: 'caodeptaccess/:id',
    component: () => import('@/components/edisbursement/maintenance/caodeptaccess/caodeptaccessEdit')
  }, {
    path: 'caodeptaccess',
    component: () => import('@/components/edisbursement/maintenance/caodeptaccess/caodeptaccessList')
  }, {
    path: 'originatordepartment',
    component: () => import('@/components/edisbursement/maintenance/originatordepartment/originatordepartmentList')
  }, {
    path: 'originatordepartment/:id',
    component: () => import('@/components/edisbursement/maintenance/originatordepartment/originatordepartmentEdit')
  }]
}]
